import React, {useEffect, useState} from 'react'
import { TableWrapper } from '../../../libs/react-mpk/wrapper'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './Ptkp.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'
import Utils from '../../../libs/custom/Utils'

var _baseId = "mod-table-ptkp"

const PtkpTable = ({
  className       = '',
  showCommandbar  = true,
  history
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
    TableWrapper.reload(_baseId)
  }

  return (
    <>
    <TableWrapper
      baseId={_baseId}
      title={t.translate('modules.ptkp.title')}
      className={className}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="createdDate"
      columns={[
        {
          label: 'Dari (Tahun)',
          searchable: true,
          key: 'dari',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.dari)
        },{
          label: 'Ke (Tahun)',
          searchable: true,
          key: 'ke',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.ke)
        },{
          label: 'Pribadi (Rp)',
          searchable: true,
          key: 'pribadi',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.pribadi))
        },{
          label: 'Tanggungan (Rp)',
          searchable: true,
          key: 'tanggungan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.tanggungan))
        },{
          label: 'K/0 (Rp)',
          searchable: true,
          key: 'k0',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.k0))
        },{
          label: 'K/1 (Rp)',
          searchable: true,
          key: 'k1',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.k1))
        },{
          label: 'K/2 (Rp)',
          searchable: true,
          key: 'k2',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.k2))
        },{
          label: 'K/3 (Rp)',
          searchable: true,
          key: 'k3',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.k3))
        },{
          label: 'TK/0 (Rp)',
          searchable: true,
          key: 'tk0',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.tk0))
        },{
          label: 'TK/1 (Rp)',
          searchable: true,
          key: 'tk1',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.tk1))
        },{
          label: 'TK/2 (Rp)',
          searchable: true,
          key: 'tk2',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.tk2))
        },{
          label: 'TK/3 (Rp)',
          searchable: true,
          key: 'tk3',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.tk3))
        }
      ]}
      actions={[
        new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push('/onpremise/ptkp/baru'), true)
      ]}
      itemActions={[
        new TableWrapper.action('Edit', 'mdi mdi-pencil', (item) => history.push(`/onpremise/ptkp/${item.id}`), true),
        new TableWrapper.action('Delete', 'mdi mdi-delete', (item) => { setConfirmDeleteData(item); setConfirmDelete(true)}, true)
      ]}
      onFetchData={ async query => {
        return service.get(query)
      }}
      showCommandbar={showCommandbar}
      showFilterPeriod={false}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    </>
  )
}

export default PtkpTable
